/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_DescriptionInputs */



/**
* | output |
* | --- |
* | "Configure CCSL export settings" |
*
* @param {Ccsl_Export_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_description = /** @type {((inputs?: Ccsl_Export_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Configurer les parametres d'exportation CCSL")
	if (locale === "de") return /** @type {LocalizedString} */ ("CCSL-Exporteinstellungen konfigurieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Configurare le impostazioni di esportazione CCSL")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройка параметров экспорта CCSL")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configurar los ajustes de exportación CCSL")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("配置 CCSL 导出设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CCSLエクスポート設定を構成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("CCSL निर्यात सेटिंग्स को कॉन्फ़िगर करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurar as definições de exportação do CCSL")
	return /** @type {LocalizedString} */ ("Configure CCSL export settings")
});